import { render, staticRenderFns } from "./Disbursement.vue?vue&type=template&id=6a99fb53"
import script from "./Disbursement.vue?vue&type=script&lang=js"
export * from "./Disbursement.vue?vue&type=script&lang=js"
import style0 from "./Disbursement.vue?vue&type=style&index=0&id=6a99fb53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports